import { render, staticRenderFns } from "./UnitsToggleComponent.vue?vue&type=template&id=4b6e6c22"
import script from "./UnitsToggleComponent.vue?vue&type=script&lang=js"
export * from "./UnitsToggleComponent.vue?vue&type=script&lang=js"
import style0 from "./UnitsToggleComponent.vue?vue&type=style&index=0&id=4b6e6c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports